import { selector } from '@poa/state';
import { makeFilteredByStatus } from '../shared/table-filtered-by-status.selector';
import { makeGetTableGroupedSelector } from '../shared/table-grouping.selector';

const getTable = makeGetTableGroupedSelector('reportArchives');
const filteredByStatus = makeFilteredByStatus(getTable, 'reportArchives');

export const filteredData = selector(store => {
  const searchText = store.reportArchives.filters.search;

  return getTable.get().map((table, idx) => {
    let tbody = filteredByStatus.get()[idx];

    // filter by input text
    if (searchText !== '') {
      tbody = tbody.filter(row => {
        let isMatched = false;

        Object.keys(row)
          .filter(key => !['id', 'status'].includes(key))
          .forEach(sectionId => {
            const sectionData = row[sectionId];

            if (!sectionData) {
              return;
            }

            // since we have status: "active" key here
            if (typeof sectionData === 'object') {
              Object.values(sectionData).forEach(cellData => {
                if (!isMatched) {
                  const value = cellData.value ? cellData.value.toString().toLowerCase() : '';
                  const search = searchText.toLowerCase();

                  isMatched = value.includes(search);
                }
              });
            }
          });

        return isMatched;
      });
    }

    return { ...table, tbody };
  });
});

export const isAllColumnsSelected = selector(store =>
  store.reportArchives.selectors.selectedPreset.columnsConfiguration.every(c => c.isSelected)
);
